export interface TipoContratoOption {
  value: number;
  label: string;
}
export const TipoContratoOptions: TipoContratoOption[] = [
  {
    value: 1,
    label: 'Contrato (termo inicial)',
  },
  {
    value: 8,
    label: 'Outros',
  },
  {
    value: 7,
    label: 'Empenho',
  },
  {
    value: 12,
    label: 'Carta Contrato',
  },
];
